import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';
import classes from './CurrentJobsScreen.admin.module.css';
import { Job } from 'modules/jobs/services/job';
import { useJobs } from 'modules/jobs/services/jobs.service';
import { BaseCurrentJobsScreen, GridRow } from './BaseCurrentJobsScreen';
import { Action } from 'modules/shared/components/DataTable/DataTable';


export function CurrentJobsAdminScreen() {
  const { deleteJob } = useJobs();
  const [jobs, setJobs] = useState<Job[]>([]);
  const navigate = useNavigate();

  const actions: Action<GridRow>[] = useMemo(() => [
    { label: 'Edit', onAction: ({ raw }) => navigate(raw.ref.id + '/edit') },
    { label: 'Delete', onAction: ({ raw }) => {
      deleteJob(raw);
      setJobs(jobs?.filter(job => job.ref.id !== raw.ref.id));
    }},
  ], [navigate, deleteJob, jobs]);

  function handleAddJob() {
    navigate('add');
  }

  return(<>
    <BaseCurrentJobsScreen actions={actions} jobs={jobs} setJobs={setJobs}/>

    <Link
      component='button'
      color='mainBackground.contrastText'
      variant='body1'
      underline='none'
      className={classes.addButton}
      onClick={handleAddJob}
    >+ Create New Job</Link>
  </>)
}
